/* eslint-disable import/prefer-default-export */
import useSiteMetadata from '../graphql/staticQueries/useSiteMetadata';

export const publishedOnly = items => {
  const { hideUnpublished: hide } = useSiteMetadata();
  return hide ? items.filter(item => item.published) : items;
};

export const getAuthorsFromPost = post => {
  const primaryAuthor = post.frontmatter.relatedAuthorObject;
  const secondaryAuthors = post.frontmatter.relatedOtherAuthorsObjects || [];
  const authors = [
    primaryAuthor,
    ...secondaryAuthors.filter(
      otherA => otherA.fields.url !== primaryAuthor.fields.url // remove duplicate author if any
    )
  ];
  return authors;
};
